import styled from "@emotion/styled";
import { Box, Container, Stack, Typography, useTheme } from "@mui/material";
import PageSectionBG from "../PageSectionBG";

interface CustomCardProps {
  title: string;
  description: string;
}

const HeroSection = ({ title, description }: CustomCardProps) => {
  const theme = useTheme();
  return (
    <PageSectionBG
      bgcolor={theme.palette.common.white}
      paddingBottom={20}
      paddingTop={20}
      id="hero"
    >
      <Container maxWidth="xl">
        <Stack
          justifyContent={"start"}
          position={"relative"}
          alignItems={"start"}
          direction={"row"}
          gap={2}
          mb={10}
        >
          <Box
            component="div"
            sx={{
              background: theme.palette.gradients.wildGreenBoy,
              backgroundImage:
                'url("../assets/capabilities/capability_texture.svg")',
              backgroundSize: "cover",
            }}
            position="absolute"
            height={"100%"}
            width="0.65rem"
            left={0}
            top={0}
          />

          <Stack
            maxWidth={{ xs: "100%", sm: "80%", md: "60%", lg: "65%" }}
            justifyContent={"start"}
            alignItems={"start"}
            direction={"column"}
            gap={2}
            pb={2}
            pl={4}
          >
            <Title variant="h1" color="primary.500">
              {title}
            </Title>

            <Typography variant="h5" color="primary" fontWeight={"300"}>
              {description}
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </PageSectionBG>
  );
};

export default HeroSection;

const Title = styled(Typography)`
  text-transform: uppercase;
  font-size: 4.5rem;
  font-weight: 700;
  line-height: 1;
`;
